var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"moveImgWrap",staticClass:"moveImgWrap",on:{"mousemove":_vm.mouseMove,"mouseleave":_vm.mouseLeave}},[_c('img',{staticClass:"moveImg",style:(("transform: translate(" + _vm.x + "px, " + _vm.y + "px)")),attrs:{"src":_vm.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }